import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current screen size is mobile
 * Breakpoint: 768px (matches Tailwind's 'md' breakpoint)
 * @returns {boolean} true if screen width is less than 768px
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
